import { query_customer_list_and_change_rate_with_customer_type } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-customer_list_with_customer_type-config';

import { reactive } from 'vue';
import moment from 'moment';
import { get_gender } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '会籍店',
      disabled: false,
      placeholder: '请选择会籍店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'adviser_id',
      label: '顾问',
      disabled: false,
      placeholder: '请选择顾问',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'rangepicker',
      name: 'date_range',
      label: '时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      valueFormat: 'YYYY-MM-DD',
      format: 'YYYY-MM-DD',
      showTime: false,
      placeholder: '请填写时间',
    },
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '客户姓名',
      disabled: false,
      placeholder: '请选择客户姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'select',
      name: 'customer_type_flag_list',
      label: '转化类型',
      disabled: false,
      placeholder: '请选择转化类型',
      mode: 'default',
      allowClear: true,
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    shop_id: null,
    customer_id: null,
    customer_type_flag_list: 'customer,new_customer',
    date_range: [moment().format('YYYY-MM-01'), moment().format('YYYY-MM-DD')],
  }),
};
const search_options = {
  customer_type_flag_list: [
    { value: 'customer_ready_to_active,customer_ready_to_active', label: '待激活散客' },
    { value: 'customer,new_customer', label: '散客转新客' },
    { value: 'customer,new_member', label: '散客转新会员' },
    { value: 'new_customer,new_member', label: '新客转新会员' },
    { value: 'new_member,old_member', label: '新会员转老会员' },
  ],
};

const edit_model_config = {};
const edit_model_config_options = {};

const update_model_config = {};
const update_model_config_options = {};

const titleList = {
  title: '客户转化记录表',
  addModalTitle: '新建客户转化记录表',
  updateTitle: '编辑客户转化记录表',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '会籍门店',
    dataIndex: 'shop__name',
    width: 130,
  },
  {
    title: '所属顾问',
    width: 120,
    dataIndex: 'adviser__name',
    checked: true,
  },
  {
    title: '客户编号',
    width: 150,
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '客户姓名',
    width: 150,
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '获客方式',
    width: 150,
    dataIndex: 'hk_type__name',
    checked: true,
  },
  {
    title: '性别',
    dataIndex: 'gender',
    width: 80,
    checked: true,
    filterMultiple: true,
    filters: [
      { text: '全部', value: '' },
      { text: '女', value: 0 },
      { text: '男', value: 1 },
    ],
    content: (record: any, text: any) => {
      return get_gender(text);
    },
  },
  {
    title: '电话',
    width: 150,
    dataIndex: 'phone',
    checked: true,
  },
  {
    title: '散客时间',
    width: 150,
    dataIndex: 'customer_type_datetime_customer',
    checked: true,
  },
  {
    title: '新客时间',
    width: 150,
    dataIndex: 'customer_type_datetime_new_customer',
    checked: true,
  },
  {
    title: '新会员时间',
    width: 150,
    dataIndex: 'customer_type_datetime_new_member',
    checked: true,
  },
  {
    title: '老会员时间',
    width: 150,
    dataIndex: 'customer_type_datetime_old_member',
    checked: true,
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_list_and_change_rate_with_customer_type,
    addData: null,
    updateData: null,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
    headerComponent: 'headerComponentMjstoreCustomerListWithCustomerType',
  };
};
